import {
  getActiveConsentManagementInfo,
  getConsentProvider,
} from '@/Integrations/Consent/consentService';

export function watchExternalContentMarketingConsent(
  onChange: (allowed: boolean) => void,
): () => void {
  const provider = getConsentProvider();

  onChange(provider.getSnapshot().marketing === true);

  return provider.subscribe((snapshot) => {
    onChange(snapshot.marketing === true);
  });
}

export function openExternalContentConsentUi(): void {
  const activeConsentManagement = getActiveConsentManagementInfo();

  if (activeConsentManagement?.provider === 'cookiebot') {
    const cookiebot = (window as { Cookiebot?: Record<string, unknown> }).Cookiebot;
    const renew = cookiebot?.renew as (() => void) | undefined;
    if (typeof renew === 'function') {
      renew.call(cookiebot);
    }
  }
}
